<template>
    <template v-if="mode === 'interno'">
        <div v-if="isVideo">
            <video controls autoplay muted loop style="max-height:500px; width: 100%;">
                <source :src="pregunta.imagen" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
        <v-img v-else max-height="500" :src="pregunta.imagen" />
    </template>
    <v-card variant="text">
        <v-card-title  class="text-wrap" style="word-break: break-word">
            {{ pregunta.texto }}
        </v-card-title>
        <v-card-text>
            <v-textarea v-model="text"></v-textarea>
        </v-card-text>
    </v-card>
    <v-btn block v-if="!haRespondido && mode !== 'teacher'" :disabled="loading" color="primary" class="mt-3" @click="enviarTexto">
        {{ t('Enviar') }}
    </v-btn>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { axios } from '../axios'; 

const props = defineProps({
    pregunta: {
        type: Object,
        default: () => ({})
    },
    mode: {
        type: String,
        default: 'interno',
        // 'interno'  => El componente hace el axios POST a enviar_respuestas/.
        // 'externo'  => El componente emite el evento con los datos, 
        //               y NO hace la petición dentro.
    },
});

const emits = defineEmits(['respuesta-enviada', 'info-respuesta']);

const { t } = useI18n();
const text = ref();
const haRespondido = ref(false);
const loading = ref(false);

function enviarTexto() {
    // enviamos un evento con la info de la respuesta para el "modo externo"
    // (o si el padre quisiera usarlo incluso en modo interno).
    emits('info-respuesta', {
        pregunta_id: props.pregunta.id,
        text: text.value,
    });

    if (props.mode === 'interno') {
        // Lógica interna de envío
        enviarAlServidor();
    } else {
        // Modo externo: no hace axios.post. Marcamos "respondido" localmente
        haRespondido.value = true;
    }
}

async function enviarAlServidor() {
    const datosParaEnviar = {
        pregunta_id: props.pregunta.id,
        text: text.value
    };
    loading.value = true;
    try {
        const respuesta = await axios.post(`enviar_respuestas/`, datosParaEnviar);
        if (respuesta.data.success) {
            console.log('Respuesta:', respuesta.data.message);
        } else {
            console.error('Error al enviar respuestas:', respuesta.data.message);
        }
        loading.value = false;
    } catch (error) {
        console.error('Error al realizar la solicitud:', error);
        loading.value = false;
    } finally {
        next();
    }
}

function next() {
    emits('respuesta-enviada', props.pregunta);
    text.value = [];
}

watch(
  () => props.pregunta?.id,
  (newId, oldId) => {
    if (newId !== oldId) {
      haRespondido.value = false;
      text.value = [];
    }
  }
);

// Check if the file is a video (mp4)
const isVideo = computed(() => {
    if (props.pregunta.value && props.pregunta.value.imagen) {
        try {
            const urlObj = new URL(props.pregunta.value.imagen);
            return urlObj.pathname.toLowerCase().endsWith('.mp4');
        } catch (e) {
            // Fallback if URL parsing fails
            return props.pregunta.value.imagen.toLowerCase().includes('.mp4');
        }
    }
    return false;
});

// Inicializar las respuestas seleccionadas con respuestas previas del usuario
onMounted(() => {
    if (props.pregunta.respuestas_usuario && props.pregunta.respuestas_usuario.length > 0) {
        text.value = props.pregunta.respuestas_usuario[0].respuesta_texto
    }
});
</script>